import React from 'react';
import get from 'lodash/get';
import { Button } from '@lendi-ui/button';
import Grid from '@lendi-ui/grid';

import { FIELD_PATHS, FIELD_VALUES } from '@funnels/constants';
import { useAnalytics } from '@funnels/providers';
import { FormValues } from '@funnels/types';
import {
  ApplicantsPanel,
  CurrentLoanPanel,
  FullWidth,
  NewLoanPreferencesPanel,
  PropertyInvolvedInLoanPanel,
} from '@funnels/ui-components';
import { run } from '@funnels/utils';

import { Container } from './index.style';

interface SummaryCardProps {
  type: FIELD_VALUES;
  formValues: FormValues;
  isVisible: boolean;
  isCurrentLoanVisible: boolean;
  onContinueClick: (event: React.SyntheticEvent<Element, Event>) => void;
  onHideClick: (event: React.SyntheticEvent<Element, Event>) => void;
  onCloneClick: (event: React.SyntheticEvent<Element, Event>) => void;
}

const LABELS = {
  HIDE: 'Hide application',
  SHOW: 'Show application',
  CONTINUE: 'Continue application',
  COPY: 'Copy application',
};

function SummaryCard(props: SummaryCardProps) {
  const { tracking } = useAnalytics();
  const { formValues, type } = props;
  const gridDesktopCols = !props.isCurrentLoanVisible ? 9 : 12;
  const unitSizes = { xs: 4 / 4, sm: 4 / 8, md: 4 / 8, lg: 4 / 8, xl: 3 / gridDesktopCols };
  const showHideLabel = props.isVisible ? LABELS.HIDE : LABELS.SHOW;
  const purchaseReason = get(formValues, FIELD_PATHS.APPLICATION_PURCHASE_REASONS(0));

  const layout = purchaseReason === FIELD_VALUES.LOAN_AFFORDABILITY ? FIELD_VALUES.PREAPPROVAL : type;

  return (
    <Container>
      <Grid gutter="sm">
        <Grid.Unit size={unitSizes} offset={0}>
          <NewLoanPreferencesPanel layout={layout} currentValues={formValues} />
        </Grid.Unit>
        {props.isCurrentLoanVisible && (
          <Grid.Unit size={unitSizes} offset={0}>
            <CurrentLoanPanel layout={layout} currentValues={formValues} />
          </Grid.Unit>
        )}
        <Grid.Unit size={unitSizes} offset={0}>
          <PropertyInvolvedInLoanPanel layout={layout} currentValues={formValues} />
        </Grid.Unit>
        <Grid.Unit size={unitSizes} offset={0}>
          <ApplicantsPanel layout={layout} currentValues={formValues} />
        </Grid.Unit>
      </Grid>
      <FullWidth>
        <Grid halign="center" gutter="sm">
          <div>
            <Button
              variant="primary"
              size="xs"
              onClick={run(props.onContinueClick, () => tracking?.button.primary({ text: LABELS.CONTINUE }))}
            >
              {LABELS.CONTINUE}
            </Button>
          </div>
          <div>
            <Button
              variant="secondary"
              size="xs"
              onClick={run(props.onCloneClick, () => tracking?.button.secondary({ text: LABELS.COPY }))}
            >
              {LABELS.COPY}
            </Button>
          </div>
          <div>
            <Button
              variant="secondary"
              size="xs"
              onClick={run(props.onHideClick, () => tracking?.button.secondary({ text: showHideLabel }))}
            >
              {showHideLabel}
            </Button>
          </div>
        </Grid>
      </FullWidth>
    </Container>
  );
}

export default SummaryCard;
